import { useSelector } from "react-redux";

import { getVerifiedAccountFlag } from "@ten24/slatwall-storefront-react-private/global";

import { isAuthenticated } from "@ten24/slatwall-storefront-react-private/global";

import ProductCardButton from "./ProductCardButton";
import { useState } from "react";

const useProductCardButton = ({ skuSettings, cardConfiguration, isProductInStock }) => {
  const isVerifiedAccount = useSelector(getVerifiedAccountFlag);
  const isAuthenticatedUser = isAuthenticated();

  // this is needed so we can calculate 6 or 12 of buttons
  const buttonStack = cardConfiguration?.buttons?.map((props) => {
    const {
      showAuthenticationRequiredMessageFlag = true,
      hideListingButton = true,
      type = "ADD_TO_CART",
      listingButtonDisplayCriteria,
    } = props;
    let criteriaPassed = false;
    if (listingButtonDisplayCriteria === "all") criteriaPassed = true;
    if (listingButtonDisplayCriteria === "showForAuthenticatedUsers") criteriaPassed = isAuthenticatedUser;
    if (listingButtonDisplayCriteria === "showForAuthenticatedUsersAndInStock")
      criteriaPassed = isAuthenticatedUser && isProductInStock;
    if (listingButtonDisplayCriteria === "showForVerifiedUsers") criteriaPassed = isVerifiedAccount;
    if (listingButtonDisplayCriteria === "showForVerifiedUsersAndInStock")
      criteriaPassed = isVerifiedAccount && isProductInStock;
    if (type === "ADD_TO_CART") {
      const authenticationRequiredForAddToCart = !!skuSettings?.skuRequireLoginToAddToCart
        ? isAuthenticatedUser
        : false;
      if ((!criteriaPassed || authenticationRequiredForAddToCart) && showAuthenticationRequiredMessageFlag)
        return { ...props, shouldDisplayAuthenticationRequiredMessageFlag: true };
    }
    if (!criteriaPassed && hideListingButton) return false;
    return props;
  });

  return buttonStack;
};

const ListingButtons = ({
  skuSettings,
  cardConfiguration,
  isProductInStock,
  productLink,
  isFetching,
  skuID,
  itemCount,
  setFetching,
  setItemCount,
}) => {
  const buttonStack = useProductCardButton({ skuSettings, cardConfiguration, isProductInStock });
  if (!buttonStack?.length) return null;

  return (
    <div className="productCard-button-container text-center border-0 bg-transparent pb-3 pt-3">
      <div className="d-flex flex-wrap px-2 gap-2">
        {buttonStack?.map((buttonProps, idx) => {
          return (
            <div key={idx} className="productCard-button">
              <ProductCardButton
                skuSettings={skuSettings}
                productLink={productLink}
                isFetching={isFetching}
                skuID={skuID}
                itemCount={itemCount}
                setFetching={setFetching}
                setItemCount={setItemCount}
                {...buttonProps}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const DropdownButtons = ({
  skuSettings,
  cardConfiguration,
  isProductInStock,
  productLink,
  isFetching,
  skuID,
  itemCount,
  setFetching,
  setItemCount,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const buttonStack = useProductCardButton({ skuSettings, cardConfiguration, isProductInStock });
  if (!buttonStack?.length) return null;
  const [button, ...buttons] = buttonStack;

  return (
    <div className="pb-3 pt-3">
      <div className="btn-group dropdown">
        <ProductCardButton
          skuSettings={skuSettings}
          productLink={productLink}
          isFetching={isFetching}
          skuID={skuID}
          itemCount={itemCount}
          setFetching={setFetching}
          setItemCount={setItemCount}
          {...button}
        />
        {buttons.length > 0 && (
          <>
            <button
              className="btn btn-sm btn-primary dropdown-toggle p-3"
              onClick={() => {
                setDropdownOpen((prevState) => !prevState);
              }}
            />
            <div
              className={`dropdown-menu p-2 flex-column align-items-center top-100 left-0 ${
                isDropdownOpen ? "show d-flex" : ""
              }`}
            >
              {buttons.map((buttonProps, idx) => {
                return (
                  <div key={idx} className="pt-2">
                    <ProductCardButton
                      skuSettings={skuSettings}
                      productLink={productLink}
                      isFetching={isFetching}
                      skuID={skuID}
                      itemCount={itemCount}
                      setFetching={setFetching}
                      setItemCount={setItemCount}
                      {...buttonProps}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { ListingButtons, DropdownButtons };
